import React from 'react';

import './index.pc.scss';
import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import PcInputItem from 'components/molecules/PcInputItem';
import PcInputTitle from 'components/molecules/PcInputTitle';
import PcAccordionTextArea from 'components/molecules/PcAccordionTextArea';
import PcStepProgressBar from 'components/molecules/PcStepProgressBar';
import PcModalBack from 'components/molecules/PcModalBack';
import PcPointComment from 'components/molecules/PcPointComment';
import PcInputHourSalary from 'components/molecules/PcInputHourSalary';

import { POINT_COMMENT_MAP } from 'utils/constant';

const PresentPC = ({
  // 表示リスト
  DispList1,
  DispList2,
  workingDayRangeOthersDisp,
  attendanceDisp,
  hourSalaryDisp,

  // onChange
  modalBackIsEnable,

  // onClick
  onClickMainButton,

  // 入力チェック
  valid,
  errorDispMap,
  isApiError,
  showLoading,

}) => (
  <div className="AddCondition PC">
    <PcBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      valid={valid}
      isApiError={isApiError}
      showLoading={showLoading}
    >
      <PcStepProgressBar currentStep='5' />
      <div id="addCondition" className="contents mT60">
        <div className="titleArea">
          <p className="title">就業条件</p>
        </div>
        <div id="dispList1" className="dispList1">
          {DispList1.map((data) => {
            return (
              <span key={data.title}>
                <PcInputItem
                  title={data.title}
                  subTitle={data.subTitle}
                  label={data.label}
                  questionMark={data.questionMark}
                  popUpTitle={data.popUpTitle}
                  popUpDetail={data.popUpDetail}
                >
                  {data.input}
                </PcInputItem>
              </span>
            );
          })}
        </div>
        <PcPointComment labelList={POINT_COMMENT_MAP.workTimePointCmnt.labelList} pattern={POINT_COMMENT_MAP.workTimePointCmnt.pattern} />
        <div id="dispList2" className="dispList2">
          {DispList2.map((data) => {
            return (
              <span key={data.title} className={data.id}>
                <PcInputItem
                  title={data.title}
                  subTitle={data.subTitle}
                  label={data.label}
                  questionMark={data.questionMark}
                  popUpTitle={data.popUpTitle}
                  popUpDetail={data.popUpDetail}
                >
                  {data.input}
                </PcInputItem>
              </span>
            );
          })}
        </div>
        <div className="workingDayRangeOthersDisp">
          <PcAccordionTextArea
            value={workingDayRangeOthersDisp.value}
            label={workingDayRangeOthersDisp.label}
            checkBoxOnChange={workingDayRangeOthersDisp.onChange}
            checked={workingDayRangeOthersDisp.checked}
            id={workingDayRangeOthersDisp.id}
            textAreaTitle={workingDayRangeOthersDisp.comment.title}
            textAreaLabel={workingDayRangeOthersDisp.comment.label}
            name={workingDayRangeOthersDisp.comment.name}
            textAreaValue={workingDayRangeOthersDisp.comment.textAreaValue}
            cmntOnChange={workingDayRangeOthersDisp.comment.cmntOnChange}
            onInput={workingDayRangeOthersDisp.comment.onInput}
            onCompositionEnd={workingDayRangeOthersDisp.comment.onCompositionEnd}
            maxLength={workingDayRangeOthersDisp.comment.maxLength}
            placeholder={workingDayRangeOthersDisp.comment.placeholder}
            rows={workingDayRangeOthersDisp.comment.rows}
            cols={workingDayRangeOthersDisp.comment.cols}
            wordCount={workingDayRangeOthersDisp.comment.wordCount}
            inValid={workingDayRangeOthersDisp.comment.inValid}
            errPosition={workingDayRangeOthersDisp.comment.errPosition}
            errMessage={workingDayRangeOthersDisp.comment.errMessage}
          />
        </div>
        <div className="attendanceDisp">
          <PcInputTitle
            title={attendanceDisp.title}
            label={attendanceDisp.label}
            list={attendanceDisp.list}
            type={attendanceDisp.type}
            childInput={attendanceDisp.childInput}
          />
        </div>
        <div className='hourSalaryDisp'>
          <PcInputItem
            title={hourSalaryDisp.title}
            subtitle={hourSalaryDisp.subtitle}
            label={hourSalaryDisp.label}
            questionMark={hourSalaryDisp.questionMark}
            popUpTitle={hourSalaryDisp.popUpTitle}
            popUpDetail={hourSalaryDisp.popUpDetail}
          >
            <>
              <div className='hourSalary'>
                <PcInputHourSalary
                  hourSalaryMin={hourSalaryDisp.input.hourSalaryMin}
                  value={hourSalaryDisp.input.hourSalaryMax}
                  onChange={hourSalaryDisp.input.onChangeHourSalaryMax}
                  onInput={hourSalaryDisp.input.onChangeHourSalaryMax}
                  onCompositionEnd={hourSalaryDisp.input.onChangeHourSalaryMax}
                  maxLength='4'
                  placeholder={hourSalaryDisp.input.placeholder}
                  inValid={hourSalaryDisp.input.inValid}
                  errMessage={errorDispMap.hourSalaryMax}
                  apiErrMessage={hourSalaryDisp.input.apiErrMessage}
                />
              </div>
            </>
          </PcInputItem>
        </div>
      </div>
      <PcModalBack modalBackIsEnable={modalBackIsEnable} />
    </PcBasicTemplate>
  </div>
);

export default PresentPC;